module.exports = __webpack_public_path__ + "img/imiwin-support.cb1882b2.png";